import { Height } from "@mui/icons-material";

export const CsvImportDialogStyle = {
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    position: "relative", // ×ボタン用
    paddingTop: 2,
    paddingBottom: 2,
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    color: "#000",
    fontWeight: "bold",
    minWidth: 48,
    padding: "2px 8px",
    fontSize: "28px",
    lineHeight: 1,
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    flexDirection: "column",
    textAlign: "center",
    gap: 0.5,
  },
  link: {
    cursor: "pointer",
    "&:hover": {
      color: "#1976d2",
      textDecoration: "underline",
    },
  },
  leftColumn: {
    width: "65%",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rightColumn: {
    width: "35%",
    padding: "24px",
    whiteSpace: "pre-wrap",
    fontSize: "0.9rem",
  },
  dropArea: {
    border: "2px dashed #888",
    borderRadius: "8px",
    padding: "40px",
    textAlign: "center",
    backgroundColor: "#fff",
    marginTop: "20px",
    transition: "background-color 0.2s ease-in-out",
    width: "90%",
    height: "90%",
    alignItems: "center",
  },
  dropAreaHover: {
    backgroundColor: "#f0f0f0",
  },
  orangeButton: {
    backgroundColor: "#f4a460",
    color: "#fff",
    fontWeight: "bold",
    marginTop: "24px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      backgroundColor: "#e38b35",
    },
  },
};
